function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.311 9.311"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.236 9.412 5 6.177 1.765 9.412A.832.832 0 0 1 .588 8.236L3.823 5 .588 1.765A.832.832 0 0 1 1.765.588L5 3.824 8.236.588a.832.832 0 0 1 1.176 1.177L6.177 5l3.235 3.236a.832.832 0 1 1-1.176 1.176",
    style: {
      fill: "current"
    },
    transform: "translate(-.344 -.345)"
  }));
};
export default SvgIconClose;